import FollowedUser from "../interfaces/models/followedUser";
import moment from "moment";

export function createFollowedUser(name, uid, start_date, avatar) {
  const user: FollowedUser = {} as any;
  user.name = name;
  user.follow_date = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
  user.uid = uid;
  user.start_date = start_date;
  user.avatar = avatar;
  return user;
}



// WEBPACK FOOTER //
// ./src/functions/createFollowedUser.tsx